export default __webpack_public_path__ + "static/webdev-56cf5843fcd00e82d71fe09dc4adaac2.jpg";